<template>
  <div
    class="the-navbar__user-meta flex items-center"
    v-if="activeUserInfo.displayName"
  >
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ user_displayName }}</p>
      <small>{{ comid }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.photoURL"
          key="onlineImg"
          :src="activeUserInfo.photoURL"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <img
          v-else
          key="localImg"
          :src="require(`@/assets/images/portrait/small/user.png`)"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/profile').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ profile }}</span>
          </li>

          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/email').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/todo').catch(() => {})">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/chat').catch(() => {})">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>-->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="goLogout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ glogout }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
// import firebase from 'firebase/app'
// import 'firebase/auth'
import langu from "../../../../views/components/langu.js";
// import axios from "axios";
// import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      comid: "",
      profile: "",
      glogout: "",
      user_displayName: "",
      addressCode: null,
      custGroupsCode: null,
    };
  },
  created() {
    // console.log(this.lang_number);
    // console.log(location.href);
    this.checkProfiles();

    // this.comid = localStorage.getItem("comid");
    this.comid = this.userRole;
    this.chLang();
  },
  watch: {
    lnchanged: function () {
      // console.log('lnchanged')
      this.chLang();
    },
    // checkComid: function(){
    //   // this.comid = localStorage.getItem("comid");
    //   this.comid = this.userRole;
    // }
  },
  computed: {
    // checkComid(){
    //   return this.$store.state.comid;
    // },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    // user_displayName() {
    //   // return localStorage.getItem("token");
    //   return this.telnum;
    // },
    lnchanged() {
      return this.$i18n.locale;
    },
  },
  methods: {
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        try {
          // const response = await axios.get(`${BASE_API_URL}/auth/profile`, {
          //   headers: { Authorization: "Bearer " + token.accessToken }
          // });

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;
          this.email = decoded.email;

          this.user_displayName = decoded.email;
          this.comid = decoded.userRole;
          this.addressCode = decoded.addressCode;
          this.custGroupsCode = decoded.custGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/pages/login/");
        }
      }
    },
    chLang() {
      // console.log('chLang');
      // this.lang_number = 'ตัวเลข'
      let curlan = this.$i18n.locale;

      if (curlan == "th") {
        // console.log(langu[0].number)
        this.profile = langu[0].profile;
        this.glogout = langu[0].logout;
      } else if (curlan == "cn") {
        // console.log(langu[1].number)
        this.profile = langu[1].profile;
        this.glogout = langu[1].logout;
      } else {
        // console.log(langu[2].number)
        this.profile = langu[2].profile;
        this.glogout = langu[2].logout;
      }
    },
    goLogout() {
      localStorage.removeItem("userRole");
      localStorage.removeItem("KK_AUTH_TOKEN");

      // this.$router.replace(url + "pages/login"); // internal link
      // console.log(url + "pages/login");
      window.location.replace("/"); // external link
      // this.$router.replace("/pages/login"); // internal link
    },
    // logout() {

    //     // if user is logged in via auth0
    //     if (this.$auth.profile) this.$auth.logOut();

    //     // if user is logged in via firebase
    //     const firebaseCurrentUser = firebase.auth().currentUser

    //     if (firebaseCurrentUser) {
    //         firebase.auth().signOut().then(() => {
    //             this.$router.push('/pages/login').catch(() => {})
    //         })
    //     }
    //     // If JWT login
    //     if(localStorage.getItem("accessToken")) {
    //       localStorage.removeItem("accessToken")
    //       this.$router.push('/pages/login').catch(() => {})
    //     }

    //     // Change role on logout. Same value as initialRole of acj.js
    //     this.$acl.change('admin')
    //     localStorage.removeItem('userInfo')

    //     // This is just for demo Purpose. If user clicks on logout -> redirect
    //     this.$router.push('/pages/login').catch(() => {})
    // },
  },
};
</script>
